import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const UpArrow = createSvgIcon(
  <path d="m19.796 10.795-1.592 1.592-5.079-5.08v12.784h-2.25V7.308l-5.08 5.079-1.59-1.592L12 3l7.796 7.795Z" />,
  'UpArrow'
);

export { UpArrow };
